import { Outlet } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Bottomline } from "./components/Bottomline";
import { CookieConsentBanner } from "./components/CookieConsentBanner";
import { TrackingManager } from "./components/TrackingManager";

// Top-level layout. The former separate Topbar has been folded into Header so
// all account/navigation controls live in the white header area.
export default function App() {
  return (
    <>
      <TrackingManager />
      <Header />

      <div className="content" id="base-content">
        <Outlet />
      </div>

      <Footer />
      <Bottomline />
      <CookieConsentBanner />
    </>
  );
}
